import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";

const config = defineConfig({
  globalCss: {
    "html, body": {
      colorPalette: "loonie",
    },
  },
  theme: {
    tokens: {
      colors: {
        loonie: {
          50: { value: "#FFF9E6" },
          100: { value: "#FFF0BF" },
          200: { value: "#FFE499" },
          300: { value: "#FFD040" },
          400: { value: "#F0B800" },
          500: { value: "#D4A017" },
          600: { value: "#B8860B" },
          700: { value: "#9A6F00" },
          800: { value: "#7A5800" },
          900: { value: "#5C4200" },
          950: { value: "#3D2D03" },
        },
      },
    },
    semanticTokens: {
      colors: {
        loonie: {
          solid: {
            value: { _light: "{colors.loonie.600}", _dark: "{colors.loonie.400}" },
          },
          contrast: {
            value: { _light: "{colors.white}", _dark: "{colors.loonie.950}" },
          },
          fg: {
            value: { _light: "{colors.loonie.700}", _dark: "{colors.loonie.300}" },
          },
          muted: {
            value: { _light: "{colors.loonie.200}", _dark: "{colors.loonie.800}" },
          },
          subtle: {
            value: { _light: "{colors.loonie.50}", _dark: "{colors.loonie.950}" },
          },
          emphasized: {
            value: { _light: "{colors.loonie.300}", _dark: "{colors.loonie.700}" },
          },
          focusRing: {
            value: { _light: "{colors.loonie.600}", _dark: "{colors.loonie.400}" },
          },
          border: {
            value: { _light: "{colors.loonie.300}", _dark: "{colors.loonie.700}" },
          },
        },
      },
    },
  },
});

export const system = createSystem(defaultConfig, config);
